import { motion } from "framer-motion";
import { AnimatedSvg } from "@/components";
import { ROUTE_DIAGRAM } from "@/content";

const SVG_STYLE = {
  width: "100%",
  height: "auto",
  fontFamily: '"Founders Grotesk", "Helvetica Neue", Arial, sans-serif',
  fontWeight: 300,
} as const;

export const RouteDiagram = () => (
  <AnimatedSvg
    viewBox="0 0 880 430"
    preserveAspectRatio="xMidYMid meet"
    role="img"
    aria-label={ROUTE_DIAGRAM.ariaLabel}
    style={SVG_STYLE}
  >
    <motion.path
      d="M60 62 H820"
      fill="none"
      stroke="#be4720"
      strokeWidth="2"
      strokeLinecap="round"
      variants={{
        hidden: { pathLength: 0, opacity: 0 },
        visible: { pathLength: 1, opacity: 1, transition: { duration: 0.8, ease: "easeOut" } },
      }}
    />
    <motion.g fill="#be4720" stroke="#f5f3f0" strokeWidth="2">
      {[60, 440, 820].map((cx, index) => (
        <motion.circle
          key={cx}
          cx={cx}
          cy="62"
          r="5"
          variants={{
            hidden: { opacity: 0, scale: 0 },
            visible: {
              opacity: 1,
              scale: 1,
              transition: { delay: 0.16 + index * 0.3, type: "spring", stiffness: 400, damping: 18 },
            },
          }}
        />
      ))}
    </motion.g>
    <motion.g
      variants={{
        hidden: { opacity: 0, y: 6 },
        visible: { opacity: 1, y: 0, transition: { delay: 0.4, duration: 0.35 } },
      }}
      fill="#474746"
      fontSize="13"
    >
      <text x="60" y="40">
        Design intent
      </text>
      <text x="440" y="40" textAnchor="middle">
        Validate digitally
      </text>
      <text x="820" y="40" textAnchor="end">
        Physical sample
      </text>
    </motion.g>
    <motion.text
      x="820"
      y="92"
      textAnchor="end"
      fill="#1a1919"
      fontSize="15"
      variants={{ hidden: { opacity: 0 }, visible: { opacity: 1, transition: { delay: 0.82, duration: 0.3 } } }}
    >
      LOOP — about one week
    </motion.text>

    <g fill="none" stroke="#6e6e6b" strokeLinejoin="round" strokeLinecap="round">
      {[
        ["M60 175 H320", "1.6"],
        ["M320 175 H600", "2.2"],
        ["M600 175 H730 C795 175 795 275 730 275 H450", "2.8"],
        ["M450 275 H210", "3.4"],
        ["M210 275 H150 C85 275 85 375 150 375 H480", "4"],
        ["M480 375 H820", "4.6"],
      ].map(([d, strokeWidth], index) => (
        <motion.path
          key={d}
          d={d}
          strokeWidth={strokeWidth}
          variants={{
            hidden: { pathLength: 0, opacity: 0 },
            visible: {
              pathLength: 1,
              opacity: 1,
              transition: { delay: 0.95 + index * 0.22, duration: 0.3, ease: "easeInOut" },
            },
          }}
        />
      ))}
    </g>
    <motion.g fill="#6e6e6b" stroke="#f5f3f0" strokeWidth="2">
      {[
        [60, 175, 4.5],
        [320, 175, 5],
        [600, 175, 5.5],
        [450, 275, 6],
        [210, 275, 6.5],
        [820, 375, 7],
      ].map(([cx, cy, r], index) => (
        <motion.circle
          key={`${cx}-${cy}`}
          cx={cx}
          cy={cy}
          r={r}
          variants={{
            hidden: { opacity: 0, scale: 0 },
            visible: {
              opacity: 1,
              scale: 1,
              transition: { delay: 1.02 + index * 0.22, type: "spring", stiffness: 350, damping: 18 },
            },
          }}
        />
      ))}
    </motion.g>
    <motion.g
      variants={{ hidden: { opacity: 0 }, visible: { opacity: 1, transition: { delay: 1.5, duration: 0.45 } } }}
      fill="#6e6e6b"
      fontSize="13"
    >
      <text x="60" y="153">
        Design intent
      </text>
      <text x="320" y="153" textAnchor="middle">
        Wait two weeks on a sample
      </text>
      <text x="600" y="153" textAnchor="middle">
        Tech pack read four ways
      </text>
      <text x="450" y="253" textAnchor="middle">
        Translate design to a knit program
      </text>
      <text x="210" y="253" textAnchor="middle">
        Re-knit — one parameter wrong
      </text>
      <text x="820" y="353" textAnchor="end">
        Physical sample
      </text>
    </motion.g>
    <motion.text
      x="820"
      y="410"
      textAnchor="end"
      fill="#1a1919"
      fontSize="15"
      variants={{ hidden: { opacity: 0 }, visible: { opacity: 1, transition: { delay: 2.22, duration: 0.35 } } }}
    >
      Traditional — about two months
    </motion.text>
  </AnimatedSvg>
);
